import { PrivateAPINamespace } from '../PrivateAPINamespace';

export class ExperimentsNamespace extends PrivateAPINamespace {
  static readonly namespace = 'experiments';

  getValue(key: string) {
    return this.ps.experimentsAPI.getValue(key);
  }

  enabled(key: string) {
    return this.ps.experimentsAPI.enabled(key);
  }

  all() {
    return this.ps.experimentsAPI.all();
  }
}
